import { useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const LoginAsUser = () => {
    const navigate = useNavigate()
    
    useEffect(() => {
        // localStorage.removeItem("coach_token")
        // localStorage.removeItem("user")
        localStorage.removeItem("selectedStudent")
        
        // Read token from cookies
        const token = Cookies.get("token")
        const user = Cookies.get("user")
    
        // If token exists, store it in localStorage
        if (token && user) {
            localStorage.setItem("coach_token", token)
            localStorage.setItem("coach_user", user)

            console.log("Token set in localStorage:", token)
            return navigate("/profile")
        } else {
            return navigate("/profile")
        }
    }, []);

    return (
        <div>LoginAsUser</div>
    )
}

export default LoginAsUser